import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock_thin",
  "use": "clock_thin-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" stroke=\"#A4A4AD\" viewBox=\"0 0 26 26\" id=\"clock_thin\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><circle cx=\"12\" cy=\"12\" r=\"12\" /><path d=\"M12 4.8V12l4.8 2.4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol